// extracted by mini-css-extract-plugin
export default {"versioning--wrapper":"Versioning_versioning--wrapper__-WkYi","versioning-loader-wrapper":"Versioning_versioning-loader-wrapper__4DZcm"};